import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TopBar } from "../components/app-shell/TopBar";
import { Sidebar } from "../components/sidebar/Sidebar";

/**
 * Top-level route. Wraps every page in the shell:
 *   - Left: GCP-style collapsible Sidebar (260px / 64px) — components/sidebar/
 *   - Top:  breadcrumb + actions (components/app-shell/TopBar)
 *   - Main: scrollable content area
 *
 * Grid is `grid-cols-[auto_1fr]` so the sidebar's own width setting drives
 * the column width without root needing to re-measure.
 */
export const rootRoute = createRootRoute({
	component: RootComp,
});

function RootComp() {
	return (
		<div className="min-h-dvh grid grid-cols-[auto_1fr] bg-white">
			<Sidebar />
			<div className="flex flex-col min-w-0">
				<TopBar />
				<main className="flex-1 bg-white p-8 overflow-y-auto">
					<Outlet />
				</main>
			</div>
		</div>
	);
}
